// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SectionContainer, SectionTitle } from "@conklin/App/Widgets/DesignSystem/DesignSystem.helpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { SizeVariant } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

interface ModalTabStyles {
    gridItem?: GridItemProps;
    modalsWrapper?: InjectableCss;
}

const modalTabStyles: ModalTabStyles = {
    gridItem: {
        width: 12,
        css: css`
            flex-wrap: wrap;
            padding-bottom: 40px;
        `,
    },
    modalsWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            flex-wrap: wrap;
        `,
    },
};

const styles = modalTabStyles;
const ModalTab: FC = props => {
    const [isOpen, setIsOpen] = useState(false);
    const [sizeVariant, setSizeVariant] = useState<SizeVariant | undefined>();

    useEffect(() => {
        if (!sizeVariant) {
            return;
        }
        setIsOpen(true);
    }, [sizeVariant]);

    return (
        <SectionContainer>
            <GridItem {...styles.gridItem}>
                <SectionTitle>Modal</SectionTitle>
                <StyledWrapper {...styles.modalsWrapper}>
                    <Button
                        onClick={() => {
                            setSizeVariant("medium");
                        }}
                        aria-label="Medium Modal"
                    >
                        Medium Modal
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setSizeVariant("large");
                        }}
                        aria-label="Large Modal"
                    >
                        Large Modal
                    </Button>
                    <Button
                        onClick={() => {
                            setSizeVariant("small");
                        }}
                        aria-label="Small Modal"
                    >
                        Small Modal
                    </Button>
                    <Modal
                        sizeVariant={sizeVariant}
                        isOpen={isOpen}
                        handleClose={() => {
                            setSizeVariant(undefined);
                            setIsOpen(false);
                        }}
                        headline="Transactional modal title"
                        contentLabel="the basic modal"
                    >
                        <>
                            <Typography> {translate("Add items to a new or existing list.")}</Typography>
                            <div data-test-selector="unhandledErrorModal">
                                {translate("Add items to a new or existing list.")}
                            </div>
                        </>
                    </Modal>
                </StyledWrapper>
            </GridItem>
        </SectionContainer>
    );
};

export default ModalTab;
